module.exports = __webpack_public_path__ + "static/desk-6b2054beeb5850ed004662a341e02a37.svg";